// extracted by mini-css-extract-plugin
export default {"fullWidth":"Gn-z","image":"Hn-z","lazyLoadPicture":"In-z","lazyLoadSpinner":"Jn-z","lazyLoadSpin":"Kn-z","lazyLoadImage":"Ln-z","hasStyledAspectRatio":"Mn-z"};